import EtchMyStore from './EtchMyStore.component';

export default EtchMyStore;
